import Color from 'color';

/**
 * Checks whether a CSS color value should be allowed or stripped. Colors that are "dark enough
 * to be black" (luminosity <= 0.05) are rejected, because they interfere with dark mode and
 * are visually indistinguishable from the default text color in light mode.
 *
 * @param {string} cssColor - any value accepted by the `color` library (hex, rgb, named, etc.)
 * @returns {boolean} true when the color should be preserved
 */
export function shouldAllowElementColor(cssColor) {
  try {
    const color = Color(cssColor);
    return color.luminosity() > 0.05;
  } catch {
    // Unsupported value (e.g. `var(--some-variable)`) — strip it
    return false;
  }
}

/**
 * Checks whether a CSS color is too light to be visible on a white background. Colors with
 * luminosity >= 0.6 are rejected, because they would be nearly invisible in standard email
 * clients. Used when serializing outbound content to prevent dark mode theme colors from
 * leaking into external HTML.
 *
 * @param {string} cssColor - any value accepted by the `color` library (hex, rgb, named, etc.)
 * @returns {boolean} true when the color should be preserved
 */
export function shouldAllowExternalColor(cssColor) {
  try {
    const color = Color(cssColor);
    return color.luminosity() < 0.6;
  } catch {
    return false;
  }
}
